import useBasePath from '@/hooks/useBasePath'

export function useIsAvaBasePath(): boolean {
  const basePath = useBasePath()
  return basePath?.toLowerCase() === 'ava'
}
